// Module
var code = "<div class=bible> <div class=bibletext> <p> <span class=cwvnum>7</span>&nbsp;&nbsp;So that they might put their trust in God&nbsp;<span class=redlight>&#149;</span><br/>&nbsp;&nbsp;&nbsp;and not forget the deeds of God,<br/>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;but keep his commandments,<br> </p> </div></div>";
// Exports
module.exports = code;